<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  mounted () {
    this.axios.interceptors.response.use(null, (error) => {
      if (error.response.status === 401) {
        this.$store.dispatch('logout')
      } else {
        this.$bvToast.toast(error.response.data, {
          title: 'Error',
          autoHideDelay: 5000,
          variant: 'danger'
        })
      }
    })
  },
  name: 'App'
}
</script>
<style>
  .navbar-nav .nav-item.active {
    background-color: black;
    margin: -8px 0;
    padding: 8px 0;
  }

  textarea {
    resize: none;
  }

  th {
    vertical-align: middle;
    text-align: center;
  }

  td:nth-child(1) { padding-left: 60px; }
  th:nth-child(1) { padding-left: 60px; }

  modal, h6{
    color:gray;
  }

  textarea[readonly] {
    border: none !important;
    background-color: white !important;
  }

  .circle {
    width: 35px;
    height: 35px;
    line-height: 35px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    margin: 0 auto 40px;
    margin-top: 35px;
    border: 1px solid #2D5A00;
  }

  .green {
    background-color: green;
    border: 1px solid #2D5A00;
  }

  .white {
    background-color: white;
    border: 1px solid #B6B6B6;
  }

  .datepicker {
    width: 120%;
  }

</style>
